import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { TextView } from 'src/core/ui/text.view';
import { DateView } from 'src/core/ui/date.view';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { AutocompleteView } from 'src/core/ui/autocomplete/autocomplete.view';
import { ClientSalutationEditorController } from '../../parts/client-salutation-editor.controller';
import { ClientTitleEditorController } from '../../parts/clienttitle-editor.controller';
import { GenderEditorView } from 'src/app/shared/parts/gender-editor.view';

interface ClientGeneralPartViewProps extends ComponentViewProps<ClientItem> {
	mode: ControlMode;
	type: 'Person' | 'Company';
	salutationQuery: DropdownRequest<AutocompleteSummary>;
	nationalityQuery: DropdownRequest<AutocompleteSummary>;
	relatedCustomersRequest: DropdownRequest<ClientSummary>;
}

@observer
export class ClientGeneralPartView extends React.Component<ClientGeneralPartViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		const type = this.props.model.type;
		const model = type == 0 ? (this.props.model.dynamicProperties['person'] as PersonItem || null) : (this.props.model.dynamicProperties['company'] as CompanyItem || null);
		if (this.props.type == 'Person') {
			return this.renderPerson(model as PersonItem);
		} else {
			return this.renderCompany(model as CompanyItem);
		}
	}

	private renderPerson(model: PersonItem) {
		if (model == null) {
			return null;
		}
		if (model.gender == null)
			model.gender = "Neutro";
		return (
			<Row gutter={16}>
				<Col xs={24} lg={12}>
					<ClientTitleEditorController
						setBusy={this.props.setBusy}
						mode={this.props.mode}
						value={model.title != null ? model.title : null}
						onChanged={newVal => model.title = newVal}
					/>
				</Col>
				<Col xs={24} lg={12}>
					<ClientSalutationEditorController
						required={true}
						setBusy={this.props.setBusy}
						mode={this.props.mode}
						value={model.salutation != null ? model.salutation : null}
						onChanged={newVal => model.salutation = newVal}
					/>
				</Col>
				<Col xs={24} lg={12}>
					<TextView
						label="First name"
						mode={this.props.mode}
						onGetErrorMessage={() => this.props.model.validate(false, 'firstName')}
						required={true}
						value={model.firstName}
						onChanged={newVal => model.firstName = newVal}
					/>
				</Col>
				<Col xs={24} lg={12}>
					<TextView
						label="Middle name"
						mode={this.props.mode}
						value={model.middleName}
						onChanged={newVal => model.middleName = newVal}
					/>
				</Col>
				<Col xs={24}>
					<TextView
						label="Last name"
						mode={this.props.mode}
						onGetErrorMessage={() => this.props.model.validate(false, 'lastName')}
						required={true}
						value={model.lastName}
						onChanged={newVal => model.lastName = newVal}
					/>
					<DateView
						label="Birthdate"
						onGetErrorMessage={() => this.props.model.validate(false, 'birthDate')}
						mode={this.props.mode}
						format='date'
						value={model.birthDate}
						onChanged={newValue => model.birthDate = newValue}
					/>
					<AutocompleteView
						label="Nationality"
						disabled={this.props.mode == 'display'}
						model={model.nationality}
						onChanged={newVal => model.nationality = newVal.value}
						request={this.props.nationalityQuery}
					/>
					<TextView
						label="Job title"
						mode={this.props.mode}
						value={model.occupation}
						onChanged={newVal => model.occupation = newVal}
					/>
				</Col>
				<Col xs={24} lg={12}>
					<GenderEditorView
						required mode={this.props.mode}
						onGetErrorMessage={() => this.props.model.validate(false, 'gender')}
						value={model.gender}
						onChanged={newVal => model.gender = newVal} />
				</Col>
				<Col xs={24} lg={12}>
					<TextView
						mode={this.props.mode}
						label="Height"
						value={model.height}
						onGetErrorMessage={() => this.props.model.validate(false, 'height')}
						onChanged={newVal => model.height = newVal} />
				</Col>
				<Col xs={24}>
					<DropdownView
						label="Related customers"
						disabled={this.props.mode == 'display'}
						model={model.relatedCustomers}
						request={this.props.relatedCustomersRequest}
						onChanged={item => {
							model.relatedCustomers = item.map(e => e.id)
						}}
						keyField="id"
						textField="displayName"
						multi
					/>
				</Col>
			</Row>
		);
	}

	private renderCompany(model: CompanyItem) {
		if (model == null) {
			return null;
		}

		return (
			<Row>
				<Col xs={24}>
					<TextView
						mode={this.props.mode}
						label="Signature"
						onGetErrorMessage={() => this.props.model.validateDynamicProperty('CompanySchemas', model, 'signature')}
						required
						value={model.signature}
						onChanged={newVal => model.signature = newVal}
					/>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/parts/clientgeneral-part.view.tsx